import { Box } from '@chakra-ui/react';
import AudioPlayer from 'components/AudioPlayer';

function AudioPreview({ formValues }: PreviewComponentProps<ContentContainer>) {
  return (
    <Box width="100%" height="100%">
      <AudioPlayer src={formValues?.audio} />
    </Box>
  );
}

export default AudioPreview;
